import React from "react"
import NextImage from "next/image"
import type { GenericImage } from "@shared/graphql.types"
import { baseContainer } from "./ColorSwatch.css"

export type Props = {
  items: GenericImage[] // current version uses images, add hex support later if needed
  visibleItemCount?: number
}

export const ColorSwatch: React.FC<Props> = ({
  items,
  visibleItemCount = 3,
}) => {
  const itemsToDisplay = items.slice(0, visibleItemCount)
  const hiddenItemCount = items.slice(visibleItemCount).length

  return (
    <div className={baseContainer}>
      {itemsToDisplay.map(({ src, altText, id }, index) => {
        const key = `swatch-${id}-${index}`
        return (
          <NextImage
            width={24}
            height={24}
            key={key}
            alt={altText ?? ""}
            src={src}
          />
        )
      })}
      {hiddenItemCount > 0 && <p>+{hiddenItemCount}</p>}
    </div>
  )
}
